import { useEffect } from "react";
import { readPageData, syncHeadMeta } from "../lib/bootConfig";

interface NotFoundTexts {
  title: string;
  "404": string;
  heading: string;
  message: string;
  home_btn: string;
  back_btn: string;
  error_code: string;
}

const DEFAULT_TEXTS: NotFoundTexts = {
  title: "Página não encontrada",
  "404": "404",
  heading: "Opa… página não encontrada",
  message:
    "A página que você está procurando pode ter sido removida, estar com o nome diferente ou estar temporariamente indisponível.",
  home_btn: "Voltar para a página inicial",
  back_btn: "Voltar à página anterior",
  error_code: "Código de erro:",
};

export function NotFoundPage() {
  const pageData = readPageData<{ page?: string; texts?: Partial<NotFoundTexts> }>();
  const t: NotFoundTexts = {
    ...DEFAULT_TEXTS,
    ...(pageData?.page === "not_found" && pageData.texts ? pageData.texts : {}),
  };

  useEffect(() => {
    syncHeadMeta({
      title: t.title,
      description: null,
      canonical: null,
      robots: "noindex",
      ogTitle: null,
    });
    document.body.className = "rp-body rp-not-found";
  }, [t.title]);

  return (
    <main
      className="rp-not-found-page"
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "2rem 1rem",
        textAlign: "center",
        background:
          "radial-gradient(circle at top left, #1d4ed8 0, #020617 40%), radial-gradient(circle at bottom right, #22c55e 0, #020617 45%)",
        color: "#e5e7eb",
        fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", sans-serif',
      }}
    >
      <h1
        style={{
          fontSize: "clamp(6rem, 20vw, 11rem)",
          fontWeight: 900,
          lineHeight: 1,
          marginBottom: "1.5rem",
          background: "linear-gradient(120deg, #22c55e, #38bdf8, #a855f7, #f97316, #22c55e)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
        }}
      >
        {t["404"]}
      </h1>

      <h2
        style={{
          fontSize: "clamp(1.8rem, 4vw, 2.5rem)",
          fontWeight: 600,
          color: "#f8fafc",
          marginBottom: "0.5rem",
        }}
      >
        {t.heading}
      </h2>

      <p
        style={{
          color: "#cbd5e1",
          fontSize: "clamp(0.95rem, 2.4vw, 1.1rem)",
          maxWidth: "36rem",
          margin: "0 auto 2rem",
        }}
      >
        {t.message}
      </p>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "0.75rem", justifyContent: "center", alignItems: "center" }}>
        <a
          href="/"
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0.75rem 2rem",
            borderRadius: "9999px",
            backgroundColor: "#f1f5f9",
            color: "#0f172a",
            fontWeight: 600,
            textDecoration: "none",
          }}
        >
          {t.home_btn}
        </a>

        <button
          type="button"
          onClick={() => window.history.back()}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0.75rem 1.5rem",
            borderRadius: "9999px",
            border: "1px solid rgba(148, 163, 184, 0.4)",
            backgroundColor: "transparent",
            color: "#f1f5f9",
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          {t.back_btn}
        </button>
      </div>

      <p style={{ marginTop: "2.5rem", fontSize: "0.75rem", color: "#94a3b8" }}>
        {t.error_code} <span style={{ fontFamily: "monospace" }}>HTTP 404</span>
      </p>
    </main>
  );
}
